/**
 * @Author: v_jppjpeng
 * @Date: 2021-11-12 15:40:04
 * @Explain: 单选
 */
import type { RadioItemType } from '@/definition/common/tdesign.d';
import { intlGet } from '@/locales';
import classNames from 'classnames';
import { Radio } from 'tdesign-react';

type PropsType = {
  className?: string;
  isShow?: boolean;
  options: RadioItemType[];
  layout?: 'column' | 'inline';
  disabled?: boolean;
  defaultValue?: any;
  value?: any;
  onChange?: (value: any, context: any) => void;
};

export default function RadioGroup(props: PropsType) {
  const {
    className,
    isShow = true,
    options,
    layout = 'inline',
    disabled = false,
    // defaultValue,
    value,
    onChange,
  } = props;

  return isShow ? (
    <Radio.Group
      // radio-group-column
      className={classNames(
        'default-td-radio-group',
        {
          [`radio-group-${layout}`]: layout,
        },
        className,
      )}
      // defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      onChange={onChange}
    >
      {options &&
        options.map((radioItem, radioIndex: number) => {
          const key = `radio-item-${radioIndex}`;
          return (
            <div
              className={classNames('radio-item', {
                'is-checked': radioItem.value === value,
                'is-disabled': radioItem.disabled,
              })}
              key={`div-${key}`}
              onClick={() => radioItem?.onClick?.(radioItem.value)}
            >
              <Radio
                value={radioItem.value}
                key={key}
                disabled={radioItem.disabled}
                style={radioItem?.style}
              >
                {radioItem?.labelKey
                  ? intlGet(radioItem.labelKey)
                  : radioItem.label}

                {radioItem.tipsKey && (
                  <div className="desc">{intlGet(radioItem.tipsKey)}</div>
                )}
              </Radio>
              {radioItem.render && radioItem.value === value && (
                <div
                  key={`render-${radioIndex.toString()}`}
                  className="custom-render"
                >
                  {radioItem.render(radioItem)}
                </div>
              )}
            </div>
          );
        })}
    </Radio.Group>
  ) : (
    <div style={{ height: '31px' }} />
  );
}
